import { useCallback } from "react";
import { useSaveRoleMutation } from "../mutations/useSaveRole.mutation";
import { RoleInterface } from "../../../interfaces/roleInterface";

export const useSaveRole = () => {
  const saveMutation = useSaveRoleMutation();

  const handleSave = useCallback(
    (values: RoleInterface) => {
      saveMutation.mutate(values);
    },
    [saveMutation],
  );

  return {
    handleSave,
    isSaving: saveMutation.isPending,
  };
};
